import { Tabs } from 'antd';
import RemainderLog from './RemainderLog';
import SetRemainderPost from './SetRemainderPost';

const SetRemainder = ({ invoiceData }: { invoiceData: any }) => (
  <>
    <Tabs
      items={[
        ...(Number(invoiceData?.net_total || 0) <=
          Number(invoiceData?.invclientpayment_amount || 0) || !!invoiceData?.invoice_is_refund
          ? []
          : [
              {
                key: '1',
                label: 'Post Remainder',
                children: <SetRemainderPost data={invoiceData} />,
              },
            ]),
        {
          key: '2',
          label: 'Logs',
          children: <RemainderLog data={invoiceData} />,
        },
      ]}
    />
  </>
);

export default SetRemainder;
